import type { Module } from '@pc/core';
import { probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';
import './events';

const ReportsOverviewPage = lazyWithReload(() => import('./pages/ReportsOverviewPage'));
const ReportsIncomePage = lazyWithReload(() => import('./pages/ReportsIncomePage'));
const ReportsExpensesPage = lazyWithReload(() => import('./pages/ReportsExpensesPage'));
const ReportsTransactionsPage = lazyWithReload(
  () => import('./pages/ReportsTransactionsPage'),
);
const ReportsDashboardWidget = lazyWithReload(
  () => import('./widgets/ReportsDashboardWidget'),
);

export const reportsModule: Module = {
  id: 'reports',
  name: 'Reports',
  description:
    'Profit & loss, channel breakdowns, and financial drill-downs across every income surface in your business.',
  basePath: '/reports',
  routes: [
    { path: '/', element: <ReportsOverviewPage /> },
    { path: '/income', element: <ReportsIncomePage /> },
    { path: '/expenses', element: <ReportsExpensesPage /> },
    { path: '/transactions', element: <ReportsTransactionsPage /> },
  ],
  navItems: [
    // Reports lives near the bottom of the operator nav next to other
    // analytical surfaces. Adjust the order key if a more prominent slot
    // becomes preferred after operator feedback.
    { label: 'Reports', to: '/reports', order: 80 },
  ],
  dashboardWidgets: [
    {
      id: 'reports-pnl',
      span: 2,
      order: 30,
      render: ReportsDashboardWidget,
    },
  ],
  events: {
    publishes: ['reports.viewed'],
  },
  healthProbe: () => probeSchemaIsExposed('reports', 'v_pnl_health'),
};
